import { render, staticRenderFns } from "./WalletWithdrawDetail.vue?vue&type=template&id=cc877aa8&scoped=true&lang=html&"
import script from "./WalletWithdrawDetail.vue?vue&type=script&lang=js&"
export * from "./WalletWithdrawDetail.vue?vue&type=script&lang=js&"
import style0 from "./WalletWithdrawDetail.vue?vue&type=style&index=0&id=cc877aa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc877aa8",
  null
  
)

export default component.exports